import { FONT_WEIGHT, TEXT_ALIGN } from '../../foundations/typography';
export const commonStyles = (FOUNDATIONS) => ({
    gap: FOUNDATIONS.spacing_150,
    text_align: TEXT_ALIGN.center,
    font_weight: FONT_WEIGHT.font_weight_600,
    border_radius: FOUNDATIONS.radius_comp_actions_buttontechonly_radiussizelarge,
    background_color: FOUNDATIONS.color_comp_actions_button_primary_default_bg,
    color: FOUNDATIONS.color_comp_actions_button_primary_default_font,
    min_width: FOUNDATIONS.size_675,
    icon: {
        height: FOUNDATIONS.size_250,
        width: FOUNDATIONS.size_250,
        color: FOUNDATIONS.color_comp_actions_button_primary_default_icon,
    },
});
export const secondaryCommonStyles = (FOUNDATIONS) => ({
    ...commonStyles(FOUNDATIONS),
    background_color: FOUNDATIONS.color_comp_actions_button_secondary_default_bg,
    color: FOUNDATIONS.color_accent_default_secondary_font_50,
    min_width: FOUNDATIONS.size_675,
    icon: {
        ...commonStyles(FOUNDATIONS).icon,
        color: FOUNDATIONS.color_comp_actions_button_secondary_default_icon,
    },
    border_width: FOUNDATIONS.border_comp_actions_buttontechonly_bordersize,
    border_color: FOUNDATIONS.color_comp_actions_button_secondary_default_border,
    border_style: 'solid',
});
export const secondaryOnSurfaceCommonStyles = (FOUNDATIONS) => ({
    ...secondaryCommonStyles(FOUNDATIONS),
    background_color: FOUNDATIONS.color_comp_actions_buttontechonly_secondaryonsurface_default_bg,
    color: FOUNDATIONS.color_comp_actions_buttontechonly_secondaryonsurface_default_font,
    min_width: FOUNDATIONS.size_675,
    icon: {
        ...secondaryCommonStyles(FOUNDATIONS).icon,
        color: FOUNDATIONS.color_comp_actions_buttontechonly_secondaryonsurface_default_icon,
    },
    border_color: FOUNDATIONS.color_comp_actions_buttontechonly_secondaryonsurface_default_border,
});
//# sourceMappingURL=commonStyles.js.map